// extracted by mini-css-extract-plugin
module.exports = {"sideMenuOptionsList":"SideBarMenu_sideMenuOptionsList__3VRid"};